import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, withCtx as _withCtx, normalizeStyle as _normalizeStyle, vShow as _vShow } from "vue";
import _imports_0 from '@/assets/codeImg.png';
import _imports_1 from '@/assets/codeImg-2.jpg';
import _imports_2 from '@/assets/codeImg-3.png';
import _imports_3 from '@/assets/hangzhou2-bottom.png';
import _imports_4 from '@/assets/logo-text.png';
const _hoisted_1 = {
  class: "user-info"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  class: "user-intro"
};
const _hoisted_4 = {
  class: "input-area"
};
const _hoisted_5 = {
  class: "countery-box"
};
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "国家/地区", -1);
const _hoisted_7 = {
  class: "phone-box"
};
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "手机号", -1);
const _hoisted_9 = {
  class: "phone-center"
};
const _hoisted_10 = {
  class: "code-box"
};
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "验证码", -1);
const _hoisted_12 = {
  class: "code-center"
};
const _hoisted_13 = ["innerHTML"];
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", {
  class: "open-app"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "潮新闻"
}), /*#__PURE__*/_createElementVNode("span", null, "下载潮新闻，赢取积分换好礼")], -1);
const _hoisted_15 = [_hoisted_14];
const _hoisted_16 = {
  class: "panel-title"
};
const _hoisted_17 = {
  class: "panel-content"
};
const _hoisted_18 = {
  class: "mask"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_index_anchor = _resolveComponent("van-index-anchor");
  const _component_van_cell = _resolveComponent("van-cell");
  const _component_van_index_bar = _resolveComponent("van-index-bar");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
    class: _normalizeClass(["invite", _ctx.bgClass])
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("img", {
    src: _ctx.queryParams.img,
    alt: "潮新闻"
  }, null, 8, _hoisted_2), _createTextVNode(" " + _toDisplayString(_ctx.queryParams.inviter), 1)]), _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.introText), 1), _createElementVNode("img", {
    class: _normalizeClass(["code-img", _ctx.mainImgClass]),
    src: _imports_0,
    alt: "潮新闻"
  }, null, 2), _createElementVNode("img", {
    class: _normalizeClass(["code-img code-img-wenzhou", _ctx.subImgClass]),
    src: _imports_1,
    alt: "潮新闻"
  }, null, 2), _createElementVNode("img", {
    class: _normalizeClass(["code-img", _ctx.thirdImgClass]),
    src: _imports_2,
    alt: "潮新闻"
  }, null, 2), _createElementVNode("div", {
    class: _normalizeClass(["code-img", _ctx.codeImgClass])
  }, null, 2), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("div", {
    class: "countery_center",
    onClick: _cache[0] || (_cache[0] = $event => $setup.handleToggleShowPanel(true))
  }, _toDisplayString(_ctx.city.countryName) + " (+" + _toDisplayString(_ctx.city.countryCode) + ") ", 1)]), _createElementVNode("div", _hoisted_7, [_hoisted_8, _createElementVNode("div", _hoisted_9, [_withDirectives(_createElementVNode("input", {
    type: "text",
    placeholder: "请输入手机号",
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.tel = $event)
  }, null, 512), [[_vModelText, _ctx.tel]])])]), _createElementVNode("div", _hoisted_10, [_hoisted_11, _createElementVNode("div", _hoisted_12, [_withDirectives(_createElementVNode("input", {
    type: "text",
    placeholder: "请输入验证码",
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.code = $event)
  }, null, 512), [[_vModelText, _ctx.code]])]), _createElementVNode("span", {
    class: "get-code",
    onClick: _cache[3] || (_cache[3] = (...args) => $setup.getCode && $setup.getCode(...args))
  }, _toDisplayString(_ctx.countdown > 0 ? _ctx.countdown : '获取验证码'), 1)])]), _createElementVNode("div", {
    class: "confirm-button",
    onClick: _cache[4] || (_cache[4] = (...args) => $setup.submit && $setup.submit(...args))
  }, _toDisplayString(_ctx.submitText), 1), _createElementVNode("div", {
    class: _normalizeClass(["rule-text", _ctx.ruleTextClass]),
    innerHTML: _ctx.ruleText
  }, null, 10, _hoisted_13), _createElementVNode("img", {
    class: _normalizeClass(["bottom-img", _ctx.thirdImgClass]),
    src: _imports_3,
    alt: "潮新闻"
  }, null, 2), _createElementVNode("div", {
    class: "open-app-container",
    onClick: _cache[5] || (_cache[5] = (...args) => $setup.openApp && $setup.openApp(...args))
  }, _hoisted_15)], 2), _createElementVNode("div", {
    class: "choice-city-panel",
    style: _normalizeStyle({
      bottom: _ctx.showPanel ? 0 : '-90vh'
    })
  }, [_createElementVNode("div", _hoisted_16, [_createTextVNode(" 选择国家或地区 "), _createElementVNode("span", {
    class: "panel-cancel",
    onClick: _cache[6] || (_cache[6] = $event => $setup.handleToggleShowPanel(false))
  }, "取消")]), _createElementVNode("div", _hoisted_17, [_createVNode(_component_van_index_bar, {
    "index-list": _ctx.codeKeys,
    sticky: false
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.codeKeys, key => {
      return _openBlock(), _createElementBlock(_Fragment, {
        key: key
      }, [_createVNode(_component_van_index_anchor, {
        index: key,
        style: {
          "background-color": "#F8F8F8"
        }
      }, null, 8, ["index"]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.codeList[key], item => {
        return _openBlock(), _createBlock(_component_van_cell, {
          key: item.countryCode,
          title: item.countryName,
          onClick: $event => $setup.handleCityItemClick(item)
        }, null, 8, ["title", "onClick"]);
      }), 128))], 64);
    }), 128))]),
    _: 1
  }, 8, ["index-list"])])], 4), _withDirectives(_createElementVNode("div", _hoisted_18, [_createElementVNode("div", {
    class: _normalizeClass(["result-dialog", _ctx.resDialogClass])
  }, [_createElementVNode("div", {
    class: "dialog-open",
    onClick: _cache[7] || (_cache[7] = (...args) => $setup.openApp && $setup.openApp(...args))
  }, "下载或打开潮新闻"), _createElementVNode("div", {
    class: _normalizeClass(["dialog-content", _ctx.resContentClass])
  }, _toDisplayString(_ctx.result), 3), _createElementVNode("span", {
    class: "close",
    onClick: _cache[8] || (_cache[8] = $event => _ctx.result = '')
  })], 2)], 512), [[_vShow, _ctx.result]])], 64);
}